export default [
  {
    path: '/saude-bucal',
    component: () => import('@/pages/SaudeBucal/Index.vue'),
  },
  {
    path: '/indicadores-aps/indicadores-esb',
    component: () => import('@/pages/IndicadoresAps/SaudeBucal/Index.vue'),
  },
  {
    path: '/saude-bucal/ceo',
    component: () => import('@/pages/SaudeBucal/Ceo/Template.vue'),
    children: [
      {
        path: '/saude-bucal/ceo',
        component: () => import('@/pages/SaudeBucal/Ceo/Index'),
      },
    ],
  },
  {
    path: '/saude-bucal/lrpd',
    component: () => import('@/pages/SaudeBucal/Lrpd/Index.vue'),
  },
  {
    path: '/saude-bucal/sesb',
    component: () => import('@/pages/SaudeBucal/Sesb/Index.vue'),
  },
  {
    path: '/indicadores-aps/indicadores-esb/primeira-consulta-programada',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/PrimeiraConsultaProgramada/components/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-aps/indicadores-esb/primeira-consulta-programada',
        component: () =>
          import(
            '@/pages/IndicadoresAps/SaudeBucal/PrimeiraConsultaProgramada/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/indicadores-aps/indicadores-esb/tratamentos-concluidos',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/TratamentosConcluidos/components/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-aps/indicadores-esb/tratamentos-concluidos',
        component: () =>
          import(
            '@/pages/IndicadoresAps/SaudeBucal/TratamentosConcluidos/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/indicadores-aps/indicadores-esb/exodontias',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/Exodontias/components/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-aps/indicadores-esb/exodontias',
        component: () =>
          import('@/pages/IndicadoresAps/SaudeBucal/Exodontias/Index.vue'),
      },
    ],
  },
  {
    path: '/indicadores-aps/indicadores-esb/escovacao-supervisionada',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/EscovacaoSupervisionada/components/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-aps/indicadores-esb/escovacao-supervisionada',
        component: () =>
          import(
            '@/pages/IndicadoresAps/SaudeBucal/EscovacaoSupervisionada/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/indicadores-aps/indicadores-esb/procedimentos-odonto-preventivos',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/ProcedimentosOdontoPreventivos/components/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-aps/indicadores-esb/procedimentos-odonto-preventivos',
        component: () =>
          import(
            '@/pages/IndicadoresAps/SaudeBucal/ProcedimentosOdontoPreventivos/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/indicadores-aps/indicadores-esb/tratamentos-restauradores-atramautico',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/TratamentoRestauradorAtraumatico/components/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-aps/indicadores-esb/tratamentos-restauradores-atramautico',
        component: () =>
          import(
            '@/pages/IndicadoresAps/SaudeBucal/TratamentoRestauradorAtraumatico/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/indicadores-aps/indicadores-esb/saude-bucal-gestantes',
    component: () =>
      import(
        '@/pages/IndicadoresAps/SaudeBucal/Gestantes/components/Template.vue'
      ),
    children: [
      {
        path: '/indicadores-aps/indicadores-esb/saude-bucal-gestantes',
        component: () =>
          import('@/pages/IndicadoresAps/SaudeBucal/Gestantes/Index.vue'),
      },
    ],
  },
]
